export function isNotNullOrUndefined(object: any) {
  return object !== null && object !== undefined;
}
